module.exports = __webpack_public_path__ + "img/MUSTANG.5c80036.jpg";